<script>
    import { navigateTo } from 'svelte-router-spa'

    export let alumno;

    const handleClick = () => {
        navigateTo(`/alumno/${alumno.id}`);
    };
</script>

<tr class="fila-alumno" on:click={handleClick}>
    <td>{alumno.apellidos} {alumno.nombres}</td>
    <td>{alumno.dni}</td>
    <td>{alumno.cohorte}</td>
    <td>{alumno.lf}</td>
    <td>8.73</td>
    <td>23%</td>
    <td>13</td>
    <td>14</td>
</tr>